<template>
    <div class="video">
        <div class="wrapper-iframe">
            <iframe v-bind:src="url" :title="'Video ID -' + id" width="560" height="314" allowfullscreen="allowfullscreen"></iframe>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            id: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                params: 'rel=0&amp;controls=0&amp;showinfo=0&amp;autoplay=0&amp;enablejsapi=1'
            }
        },
        computed: {
            url() {
                return `https://www.youtube.com/embed/${this.id}?${this.params}`
            }
        }
    }
</script>
